export default "__VITE_ASSET__95a19449__"